"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _closestEdge = require("@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge");

var _combine = require("@atlaskit/pragmatic-drag-and-drop/combine");

var _adapter = require("@atlaskit/pragmatic-drag-and-drop/element/adapter");

var _setCustomNativeDragPreview = require("@atlaskit/pragmatic-drag-and-drop/element/set-custom-native-drag-preview");

var _logic = require("../logic");

var useDraggableListItem = function useDraggableListItem(setDraggableState, setClosestEdge, useListContext, item, index) {
  var _useListContext = useListContext(),
      instanceId = _useListContext.instanceId;

  var itemRef = (0, _react.useRef)(null);
  var dragHandleRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var element = itemRef.current;
    var dragHandle = dragHandleRef.current;
    if (element === null || dragHandle === null) return;
    var data = (0, _logic.getItemData)({
      item: item,
      index: index,
      instanceId: instanceId
    }); // eslint-disable-next-line consistent-return

    return (0, _combine.combine)((0, _adapter.draggable)({
      element: dragHandle,
      getInitialData: function getInitialData() {
        return data;
      },
      onGenerateDragPreview: function onGenerateDragPreview(_ref) {
        var nativeSetDragImage = _ref.nativeSetDragImage;
        (0, _setCustomNativeDragPreview.setCustomNativeDragPreview)({
          nativeSetDragImage: nativeSetDragImage,
          render: function render(_ref2) {
            var container = _ref2.container;
            setDraggableState({
              type: 'preview',
              container: container
            });
            return function () {
              return setDraggableState(_logic.draggingState);
            };
          }
        });
      },
      onDragStart: function onDragStart() {
        return setDraggableState(_logic.draggingState);
      },
      onDrop: function onDrop() {
        return setDraggableState(_logic.idleState);
      }
    }), (0, _adapter.dropTargetForElements)({
      element: element,
      canDrop: function canDrop(_ref3) {
        var source = _ref3.source;
        return (0, _logic.isItemData)(source.data) && source.data.instanceId === instanceId;
      },
      getData: function getData(_ref4) {
        var input = _ref4.input;
        return (0, _closestEdge.attachClosestEdge)(data, {
          element: element,
          input: input,
          allowedEdges: ['top', 'bottom']
        });
      },
      onDrag: function onDrag(_ref5) {
        var self = _ref5.self,
            source = _ref5.source;
        var isSource = source.element === element;

        if (isSource) {
          setClosestEdge(null);
          return;
        }

        var closestEdge = (0, _closestEdge.extractClosestEdge)(self.data);
        var sourceIndex = source.data.index;
        if (typeof sourceIndex !== 'number') return;
        var isItemBeforeSource = index === sourceIndex - 1;
        var isItemAfterSource = index === sourceIndex + 1;
        var isDropIndicatorHidden = isItemBeforeSource && closestEdge === 'bottom' || isItemAfterSource && closestEdge === 'top';

        if (isDropIndicatorHidden) {
          setClosestEdge(null);
          return;
        }

        setClosestEdge(closestEdge);
      },
      onDragLeave: function onDragLeave() {
        return setClosestEdge(null);
      },
      onDrop: function onDrop() {
        return setClosestEdge(null);
      }
    }));
  }, [instanceId, item, index]);
  return {
    itemRef: itemRef,
    dragHandleRef: dragHandleRef
  };
};

var _default = exports["default"] = useDraggableListItem;